// extracted by mini-css-extract-plugin
export default {"disableContainer":"styles_disableContainer__id+E-","disableLabel":"styles_disableLabel__HBGRT","disableButton":"styles_disableButton__tUPBA"};